import { AnimatedContentLoader, Button } from '@components'
import { useBusinessContext } from '@context'
import { fetchBankIntegrations } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaPlus } from 'react-icons/fa'
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { BankIntegration } from './BankIntegration'
import { BankIntegrationLander } from './BankIntegrationLander'

export const BankIntegrations: React.FC = () => {
  const [t] = useTranslation()

  const { slug } = useBusinessContext()

  const { data, isLoading } = useQuery({
    queryKey: [slug, 'bank_integrations'],
    queryFn: () => fetchBankIntegrations({ slug })
  })

  const integrations = data?.results

  if (integrations?.length === 0) {
    return (
      <AnimatedContentLoader isLoading={isLoading}>
        <BankIntegrationLander />
      </AnimatedContentLoader>
    )
  }

  return (
    <>
      <BankIntegrationWrapper>
        {integrations?.map(integration => (
          <BankIntegration key={integration.id} integration={integration} />
        ))}
      </BankIntegrationWrapper>

      <ButtonWrapper>
        <Link to={`/${slug}/bank-integration-flow/aspsps`}>
          <Button icon={<FaPlus />} intent="default">
            {t('settings.integrations.bank.createButton')}
          </Button>
        </Link>
      </ButtonWrapper>
    </>
  )
}

const BankIntegrationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
  margin-bottom: ${({ theme }) => theme.spacing.md}rem;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
